export default "__VITE_ASSET__DiX2T1zr__"